import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as actionTypes from './actionTypes';
import axios from 'axios';
import { translateError, translateErrorWithKey } from '../shared/utils/Errors';
import Cookies from 'js-cookie'


const controllerUrl = '/auth/';

const getPersonalInfoCall = () => new Promise((resolve, reject) => {
    axios.get(controllerUrl + "personal").then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const getCookieCall = () => new Promise((resolve, reject) => {
    axios.get(controllerUrl + "read-cookie").then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const setTokenBearerCall = () => new Promise((resolve, reject) => {
    axios.get(controllerUrl + "read-session").then(response => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + response.data;
    }).catch(e => console.log(e));
});

const loginCall = credentials => new Promise((resolve, reject) => {
    axios.post(controllerUrl, credentials).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const logoutCall = () => new Promise((resolve, reject) => {
    axios.delete(controllerUrl + 'logout').then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const forgetPasswordCall = email => new Promise((resolve, reject) => {
    axios.post(controllerUrl + 'forgot', email).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const resetPasswordCall = ({ activationCode, userId, password }) => new Promise((resolve, reject) => {
    axios.post(controllerUrl + 'activate/' + userId, {
        activationCode,
        password
    }).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

/* const getPersonalInfoCall = () => new Promise((resolve, reject) => {
    axios.get(controllerUrl + 'personal').then(
        response => resolve(response.data),
        error => reject(error)
    );
}); */


function* login(credentials) {
    try {
        const { token, email, password, adfsEntity } = credentials.userCredentials;
        let sessionToken = token;
        //Authenticate user if token not received (received in adfs scenarios)
        if (!token) {
            const { sessionToken: st } = yield call(loginCall, {
                email: email.value,
                password: password.value
            });
            sessionToken = st;
        }

        axios.defaults.headers['Authorization'] = 'Bearer ' + sessionToken;
        const user = yield call(getCookieCall);


        const userData = {
            ...user,
            sessionToken,
            adfsEntity: adfsEntity
        };

        /*   localStorage.setItem('user_session', JSON.stringify(userData)); */
        Cookies.set('user-logged-in', true, {
            secure: true,
            sameSite: "strict",
        })


        yield put({
            type: actionTypes.LOGIN_SUCCESS,
            payload: userData
        });
    } catch ({ response }) {
        // Response object includes response status code ('status') and text ('statusText')
        yield put({
            type: actionTypes.LOGIN_FAILED,
            payload: translateError('auth', response?.status)
        });
    }
}

function* logout({ sessionExpired = false }) {
    const sessionExpiredPayload = sessionExpired ? translateErrorWithKey('auth', 'sessionExpired') : '';
    try {
        /*      const {adfsEntity} = JSON.parse(localStorage.getItem('user_session')); */
        Cookies.remove('user-logged-in')
        /*   localStorage.clear(); */
        yield put({
            type: actionTypes.LOGOUT_SUCCESS,
            payload: sessionExpiredPayload
        });
/*        if (adfsEntity) {
            window.location.href = process.env.REACT_APP_ADFS_LOGOUT_URL;
        } else {*/
            yield call(logoutCall);
    } catch (e) {
        /*      localStorage.clear(); */
        Cookies.remove('user-logged-in')

        yield put({
            type: actionTypes.LOGOUT_SUCCESS,
            payload: sessionExpiredPayload
        });
    }
}

function* forgetPassword(email) {
    try {
        yield call(forgetPasswordCall, email);
        yield put({
            type: actionTypes.FORGOT_PASSWORD_SUCCESS
        });
    } catch ({ response }) {
        yield put({
            type: actionTypes.FORGOT_PASSWORD_FAILED,
            payload: translateError('auth', response.status, response.data.status)
        });
    }
}

function* resetPassword({ userResetPassword: { activationCode, userId, password } }) {
    try {
        yield call(resetPasswordCall, { activationCode, userId, password });
        yield put({
            type: actionTypes.RESET_PASSWORD_SUCCESS,
        });
    } catch ({ response }) {
        yield put({
            type: actionTypes.RESET_PASSWORD_FAILED,
            payload: translateError('users', response.status, response.data.status)
        });
    }
}

function* getUserPersonalInfo() {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            console.log("userPersonalInfo resetting user state");
            yield call(getUserPageRefresh);
        }
        else {console.log("personal userAlreadyDefined", userDefined);}
        const user = yield call(getPersonalInfoCall);
        user.timezone = user.timeZone;
        yield put({
            type: actionTypes.GET_PERSONAL_INFO_SUCCESS,
            payload: user
        });
    } catch (e) {
        yield put({
            type: actionTypes.GET_PERSONAL_INFO_FAILED,
            payload: e
        });
    }
}

export function* getUserPageRefresh() {
    try {
        const user = yield call(getCookieCall);
        if(!axios.defaults.headers.common['Authorization']){
            yield call(setTokenBearerCall);
        }
        user.timezone = user.timeZone;
        console.log("page refreshed, rehydrating user state");
        yield put({
            type: actionTypes.GET_USER_PAGE_REFRESH_SUCCESS,
            payload: user
        });
    } catch (e) {
        yield put({
            type: actionTypes.GET_PERSONAL_INFO_FAILED,
            payload: e
        });
    }
}

const authSagas = [
    takeEvery(actionTypes.LOGIN_REQUEST, login),
    takeEvery(actionTypes.LOGOUT_REQUEST, logout),
    takeEvery(actionTypes.FORGOT_PASSWORD_REQUEST, forgetPassword),
    takeEvery(actionTypes.RESET_PASSWORD_REQUEST, resetPassword),
    takeEvery(actionTypes.GET_PERSONAL_INFO_REQUEST, getUserPersonalInfo),
    takeEvery(actionTypes.GET_USER_PAGE_REFRESH_REQUEST, getUserPageRefresh)
];

export { authSagas };
